/**
 * Auth helpers shared by the login page and inline gates.
 *
 * Centralised so the Emergent OAuth URL only lives in one place — any future
 * change to the auth host or redirect contract stays here.
 */

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH.
const EMERGENT_AUTH_URL = "https://auth.emergentagent.com/";

/**
 * Kick off the Emergent-managed Google OAuth flow.
 * @param {string} [returnPath] — path (default: current page) the user lands on
 *   after Google sign-in completes. The AuthCallback then handles the session
 *   exchange and routes them on.
 */
export function startGoogleOAuth(returnPath) {
  const path =
    returnPath || (typeof window !== "undefined" ? window.location.pathname : "/oracle");
  const redirectUrl = window.location.origin + path;
  window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
}
